// extracted by mini-css-extract-plugin
export default {"heading3":"heading-03_heading3__c8KIS","semibold":"heading-03_semibold__hJi1x","bold":"heading-03_bold__D6Tdb","error":"heading-03_error__i3i3A"};